import { GatheringDetailPage } from './gathering-detail-page';

export const ServiceDetailPage = () => <GatheringDetailPage kind="service" />;
